import React from "react";
import Draggable from "react-draggable";
import { XLg } from "react-bootstrap-icons";

const Reference = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <Draggable>
      <div
        className="calculator-container"
        style={{
          position: "fixed",
          top: "15%",
          right: "10%",
          zIndex: 100,
          backgroundColor: "white",
        }}
      >
        <header
          style={{
            width: "100%",
            position: "absolute",
            top: "-27px",
            right: "0",
            backgroundColor: "black",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 5px",
            color: "white",
            cursor: "move",
          }}
        >
          <h6 style={{ margin: 0 }}>Reference Sheet</h6>
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              marginLeft: "35px",
            }}
          >
            <div className="handle">
              <i className="fas fa-arrows-alt" style={{ color: "white" }}></i>
            </div>
          </div>
          <div>
            <button
              onClick={onClose}
              style={{ background: "none", border: "none", color: "white" }}
            >
              <XLg />
            </button>
          </div>
        </header>
        <div style={{ marginTop: "-3px" }}>
          <img
            src="/MathReference.jpg"
            alt="math-reference-sheet"
            height={400}
          />
        </div>
      </div>
    </Draggable>
  );
};

export default Reference;
